import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { PixIntegrationService } from '../../../../modules/project-valuation/services/pix-integration-service.service';
import { forkJoin } from 'rxjs';
import { CompsIntegrationEnum } from '../models/enums/comps-integration-enum';

/**
 * Properties Comparables Sidebar
 */
@Component({
  selector: 'properties-comparables-sidebar',
  templateUrl: './properties-comparables-sidebar.component.html',
  styleUrls: ['./properties-comparables-sidebar.component.scss', '../../../../modules/project-valuation/import/import-wizard/import-wizard.component.css', '../../../../modules/app-dataverse/components/v2/fields-overview/fields-overview.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PropertiesComparablesSidebarComponent extends DestroyBase implements OnInit {
  /**
   * The subjectPropertyId
   */
  @Input() subjectPropertyId: string;

  /**
 * Has sales comparables?
 */
  @Input() hasSalesComparables: boolean;

  /**
   * Has leasing comparables?
   */
  @Input() hasLeaseComparables: boolean;

  /**
   * Has I&E comparables?
   */
  @Input() hasIEComparables: boolean;

  /**
 * The PixIntegrationService
 */
  private _pixIntegrationService: PixIntegrationService;

  /**
   * Colapse pane event
   */
  @Output() closePane: EventEmitter<any> = new EventEmitter();

  /**
   * Should the dialog be closed?
   */
  shouldClose = false;

  /**
   * Close was clicked
   */
  onCloseClicked() {
    this.shouldClose = true;
    setTimeout(() => {
      this.closePane.emit();
    }, 500);//let animation finish
  }

  /**
   * Pix Comps Responses for sales
   */
  pixCompsSalesResponse: any[] = [];

  /**
   * Pix Comps Responses for leases
   */
  pixCompsLeaseResponse: any[] = [];

  /**
   * Pix Comps Responses for I&E
   */
  pixCompsIEResponse: any[] = [];

  /**
   * Sales grid collapsed?
   */
  isSaleGridCollapsed = false;
  /**
   * Leases grid collapsed?
   */
  isLeaseGridCollapsed = false;
  /**
   * I&E grid collapsed?
   */
  isIEGridCollapsed = false;

  /**
   * Constructor
   * @param _pixIntegrationService PixIntegrationService
   */
  constructor(pixIntegrationService: PixIntegrationService) {
    super();
    this._pixIntegrationService = pixIntegrationService;
  }

  /**
   * ToggleSaleGrid
   */
  toggleSaleGrid() {
    this.isSaleGridCollapsed = !this.isSaleGridCollapsed;
  }

  /**
   * toggleLeaseGrid
   */
  toggleLeaseGrid() {
    this.isLeaseGridCollapsed = !this.isLeaseGridCollapsed;
  }

  /**
  * toggleIEGrid
  */
  toggleIEGrid() {
    this.isIEGridCollapsed = !this.isIEGridCollapsed;
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    const compsSalesResponse$ = this._pixIntegrationService.getCompsResponse(this.subjectPropertyId, this.compsIntegrationType.Sale);
    const compsLeaseResponse$ = this._pixIntegrationService.getCompsResponse(this.subjectPropertyId, this.compsIntegrationType.Lease);
    const compsIEResponse$ = this._pixIntegrationService.getCompsResponse(this.subjectPropertyId, this.compsIntegrationType.IE);

    forkJoin([compsSalesResponse$, compsLeaseResponse$, compsIEResponse$]).subscribe(([salesResponse, leaseResponse, IEResponse]) => {
      if (salesResponse) {
        this.processCompsResponse(salesResponse, this.pixCompsSalesResponse);
      }
      if (leaseResponse) {
        this.processCompsResponse(leaseResponse, this.pixCompsLeaseResponse);
      }
      if (IEResponse) {
        this.processCompsResponse(IEResponse, this.pixCompsIEResponse);

      }
    });
  }

  /**
 * Get Comps Integration Enum Type
 */
  public get compsIntegrationType(): typeof CompsIntegrationEnum {
    return CompsIntegrationEnum;
  }

  /**
   * Processes a PIX Comps response
   * @param compsResponse
   * @param pixCompsResponse
   */
  private processCompsResponse(compsResponse: any, pixCompsResponse: any[]): void {
    compsResponse?.Comparables.forEach(comparables => {
      comparables?.Features?.EN.forEach(basket => {
        pixCompsResponse.push({ comparable: comparables, basket: basket });
      });
    });
  }
}
